import { DocsHeading } from "../../../../src/components/DocsHeading";
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import { Input, PasswordInput, Textarea } from 'react-magma-dom';
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  DocsHeading,
  LeadParagraph,
  Input,
  PasswordInput,
  Textarea,
  Link,
  React
};